import PropTypes from 'prop-types';
import React, { Component } from 'react';

import defined from '~app/core/defined';

import PerfectScrollbarContainer from './PerfectScrollbarContainer';
import TabControl from './TabControl';

class TabbedDisplay extends Component {

  state = {
    content: null,
  };

  componentWillMount() {
    const index = defined(this.props.initialIndex) ?
      Math.min(Math.max(this.props.initialIndex, 0), this.props.children.length - 1) :
      0;

    if (React.Children.count(this.props.children) > 0) {
      this.setCurrentChild(this.props.children[index]);
    }
  }

  render() {
    return (
      <div className="TabbedDisplay">
        <div className="TabbedDisplay__horizontalDivider" />
        <TabControl
          initialIndex={this.props.initialIndex}
          buttonDefs={this.props.children.map(::this.generateButtonDef)}
        />
        <div className="TabbedDisplay__horizontalDivider" />

        <PerfectScrollbarContainer
          verticalScroll={false}
        >
          {this.state.content}
        </PerfectScrollbarContainer>
      </div>
    );
  }

  setCurrentChild(child) {
    this.setState({
      content: child.props.children,
    });
  }

  generateButtonDef(child) {
    return {
      title: child.props.title,

      // When you click the button associated with a TabbedContent child,
      // make the TabbedContent's children the current content to render in
      // our container.
      onClick: () => {
        this.setCurrentChild(child);
      },
    };
  }
}

TabbedDisplay.propTypes = {
  initialIndex: PropTypes.number,
};

export default TabbedDisplay;



// WEBPACK FOOTER //
// ./src/components/TabbedDisplay.js